module.exports = __webpack_public_path__ + "img/lviv.858bf7e0.png";